import { LuCarFront, LuKeySquare, LuScanFace } from "react-icons/lu";
import { PiQrCodeBold } from "react-icons/pi";

export const InvitationTypeIcons = {
   VEHICLE: LuCarFront,
   FACIAL: LuScanFace,
   VIRTUAL_KEY: LuKeySquare,
   QRCODE: PiQrCodeBold,
}